<template>
  <marketing-automation-form-panel-section :title="$t('message.automation.message.setEntryCriteria')">
    <app-select :value="value.stepType"
                class="marketing-automation-form-panel-entry-section-select"
                :data-title="selectTypeTitle"
                data-menu-width="auto"
                :data-items="stepTypeOptions"
                :data-search="false"
                small
                @input="emitInput('stepType', $event)"
                @opened="emitOpened"
                @hidden="emitHidden" />

    <div class="marketing-automation-form-panel-entry-section-counter">

      <div v-if="isBirthdayType"
           class="marketing-automation-form-panel-entry-section-counter-item">
        {{$t('message.automation.message.hasBirthdayIn')}}
        <text-field class="marketing-automation-form-panel-entry-section-counter-item-inpt"
                    :value="value.daysBeforeBirthdate"
                    :hide-details="true"
                    :min="0"
                    type="number"
                    @input="emitInput('daysBeforeBirthdate', $event)"></text-field>
          {{$t('message.automation.message.days')}}
      </div>

      <div v-if="isStartByAccessType"
           class="marketing-automation-form-panel-entry-section-counter-item">
          {{$t('message.automation.message.customerPerformed')}}
        <text-field class="marketing-automation-form-panel-entry-section-counter-item-inpt"
                    :value="value.accessCounter"
                    :hide-details="true"
                    :min="0"
                    type="number"
                    @input="emitInput('accessCounter', $event)"></text-field>
          {{$t('message.generics.message.accesses')}}
      </div>

      <div v-if="isStartByPeriodWithoutAccessType"
           class="marketing-automation-form-panel-entry-section-counter-item">
          {{$t('message.automation.message.customerWithoutAccessFor')}}
        <text-field class="marketing-automation-form-panel-entry-section-counter-item-inpt"
                    :value="value.daysWithoutAccess"
                    :hide-details="true"
                    :min="0"
                    type="number"
                    @input="emitInput('daysWithoutAccess', $event)"></text-field>
          {{$t('message.automation.message.days')}}
      </div>
    </div>
  </marketing-automation-form-panel-section>
</template>

<script>
import TextField from "@components/form/TextField.vue";
import MarketingAutomationFormPanelSection from "@components/modules/marketing/automation/form/steps/panel/section/MarketingAutomationFormPanelSection.vue";
import AppSelect from "@components/Select";
import { cloneDeep } from "lodash";

export default {
  components: {
    MarketingAutomationFormPanelSection,
    AppSelect,
    TextField,
  },

  props: {
    value: {
      type: Object,
      default() {
        return {
          stepType: undefined,
          daysWithoutAccess: undefined,
          accessCounter: undefined,
          daysBeforeBirthdate: undefined,
        };
      },
    },
  },

  computed: {
    selectTypeTitle() {
      return this.value.stepType
        ? this.stepTypeOptions.find(
            (option) => option.id === this.value.stepType
          ).label
        : this.$t('message.automation.message.select');
    },
    isBirthdayType() {
      return this.value.stepType === "START_BY_BIRTHDATE";
    },
    isStartByAccessType() {
      return this.value.stepType === "START_BY_ACCESS_COUNT";
    },
    isStartByPeriodWithoutAccessType() {
      return this.value.stepType === "START_BY_PERIOD_WITHOUT_ACCESS";
    },
  },

  data() {
    return {
      stepTypeOptions: [
        {
          id: "START_BY_ACCESS",
          label: this.$t('message.automation.message.accessMade'),
        },
        {
          id: "START_BY_PERIOD_WITHOUT_ACCESS",
          label: this.$t('message.automation.message.periodWithoutAccess'),
        },
        {
          id: "START_BY_ACCESS_COUNT",
          label: this.$t('message.automation.message.numberOfAccesses'),
        },
        {
          id: "START_BY_BIRTHDATE",
          label: this.$t('message.automation.message.birthday'),
        },
        {
          id: "START_BY_CAMPAIGN",
          label: this.$t('message.automation.message.campaign'),
        },
        {
          id: "START_BY_EXTERNAL_DATABASE",
          label: "Base de dados externa",
        },
      ],
    };
  },

  methods: {
    emitOpened() {
      this.$emit("opened");
    },
    emitHidden() {
      this.$emit("hidden");
    },
    emitInput(key, val) {
      const value = cloneDeep(this.value);

      value[key] = val;

      this.$emit("input", value);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@variables";

.marketing-automation-form-panel-entry-section-counter {
  .marketing-automation-form-panel-entry-section-counter-item {
    font-weight: 600;
    color: #707070;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    margin-top: 15px;
  }

  .marketing-automation-form-panel-entry-section-counter-item-inpt {
    flex: 0;
    flex-basis: 25px;
    padding: 0 !important;
    margin: 0 7px !important;

    ::v-deep input {
      text-align: center;
      color: #707070;
    }
  }
}
.marketing-automation-form-panel-entry-section-select {
  margin: 0 auto;
}
</style>
